import { useEffect } from "react"
import useHomeList from "../../hooks/component/useHomeList"
import FullLaout from '../../component/FullLayout'
import BaseBox from '../../component/BaseBox'
import { useLocation, useParams } from "react-router-dom"
import './index.less'
const NoticeInfo = ()=>{
    const {state:noticeInfo} = useLocation()
    console.log('notitit', noticeInfo)

    
    
    return <FullLaout title={'公告訊息'} rightIcon={<></>} showFooter = {false}>
        <BaseBox style={{padding:"0 0.16rem",}} >
         
        <div style={{color:"#fff", fontSize:"0.16rem", fontWeight:"700", textAlign:"center", marginBottom:"0.2rem"}}>{noticeInfo?.title}</div>

        <div className='notice-info' dangerouslySetInnerHTML={{ __html: noticeInfo?.body }}></div>
        
        </BaseBox>
      
        {/* <BottomFalg  {... (noticeList?.length<10 && {style:{position:"fixed", bottom:"0.2rem", width:"100%", }})}/> */}
    </FullLaout>

}

export default NoticeInfo